// styles
import Styled from "./FlightDetails.styled";

// hooks
import useStateOfFlightDetails from "@/hooks/useStateOfFlightDetails";

// types
import { APP_PAGES } from "@tajawal/web-core-sdk-v2/lib/constants";
import { FlightProductModel } from "@tajawal/web-flights-sdk/lib/types/flight-product.types";
import {
  DomesticItinerary,
  ItineraryModel,
} from "@tajawal/web-flights-sdk/lib/types/itinerary.types";
import type FlightInfoStore from "@tajawal/web-flights-sdk/lib/stores/flight-info.store";
import { GenericCallback } from "@/types/common.types";
import dynamic from "next/dynamic";
import type { Store } from "@/stores";

// components
import FlightDetailsSkeleton from "@/app-desktop/containers/FlightDetails/components/FlightDetailsSkeleton";

const FlightSummary = dynamic(
  () => import("@/app-desktop/containers/FlightSummary/FlightSummary"),
  {
    loading: () => <FlightDetailsSkeleton />,
  },
);

export type FlightDetailsProps = {
  isOpen: boolean;
  currentDomesticStep?: string;
  currentPage?: string;
  flightProduct: FlightProductModel;
  flightInfoStore: FlightInfoStore;
  itinerary: ItineraryModel | DomesticItinerary;
  displayItinerary?: ItineraryModel | DomesticItinerary;
  onClose?: () => void;
  onContinue?: GenericCallback;
  hasRewards?: boolean;
  store: Store;
  showControlVariant?: boolean;
};

function FlightDetails({
  isOpen,
  flightProduct,
  flightInfoStore,
  itinerary,
  displayItinerary,
  onClose,
  currentPage = APP_PAGES.FLIGHTS_RESULTS,
  onContinue,
  currentDomesticStep = "",
  hasRewards,
  store,
  showControlVariant = true,
}: FlightDetailsProps): JSX.Element {
  const { amenities, $resources, $currency } =
    useStateOfFlightDetails(flightInfoStore);

  return (
    <Styled.Drawer anchor="right" open={isOpen} onClose={onClose}>
      <FlightSummary
        resources={$resources}
        amenitiesMap={amenities}
        itinerary={itinerary}
        flightProduct={flightProduct}
        flightInfoStore={flightInfoStore}
        currentPage={currentPage}
        onContinue={onContinue}
        onClose={onClose}
        currentDomesticStep={currentDomesticStep}
        hasRewards={hasRewards}
        store={store}
        displayItinerary={displayItinerary}
        showControlVariant={showControlVariant}
        $currency={$currency}
      />
    </Styled.Drawer>
  );
}

export default FlightDetails;
